@import './pn-sidenav-common.scss';
@import '../../../globals/main.scss';

pn-sidenav-togglebutton {
  display: block;
  width: 100%;
  padding: 0.8rem 1.6rem;
  background: $blue25;
  @media screen and (min-width: $sidenav-media-abovemobilemode) {
    display: none;
  }
}
